import { useCallback } from 'react';
import { getClientType } from './useClientType';
import { useEnvironment } from './useEnvironment';

export type BuildOneUpHealthConnectUrlRequest = (oneUpHealthConnectUrl: string) => string;

export type UseBuildOneUpHeathConnectUrlReturnValue = {
    buildOneUpHealthConnectUrl: BuildOneUpHealthConnectUrlRequest;
};

export function useBuildOneUpHealthConnectUrl(): UseBuildOneUpHeathConnectUrlReturnValue {
    const environment = useEnvironment();

    const buildOneUpHealthConnectUrl: BuildOneUpHealthConnectUrlRequest = useCallback(
        (oneUpHealthConnectUrl: string) => {
            if (environment === 'loading') return '';

            const baseUrl = {
                dev: 'https://dev.primaryrecord.app/handle-1up-redirect',
                prod: 'https://www.primaryrecord.app/handle-1up-redirect',
            };

            const connectUrl = `${baseUrl[environment]}?connectUrl=${encodeURIComponent(
                oneUpHealthConnectUrl,
            )}&sourceClientType=${getClientType()}`;

            return connectUrl;
        },
        [environment],
    );

    return {
        buildOneUpHealthConnectUrl,
    };
}
